import type { ParsedUrlQuery } from 'node:querystring';
import sanitize from 'sanitize-html';

const TEMPLATE_REGEX = /{{\s*(\w+)\s*}}/g;

export const getTemplateVariableNames = (template: string): string[] => {
  const variables: string[] = [];

  let match = TEMPLATE_REGEX.exec(template);

  while (match !== null) {
    variables.push(match[1]);
    match = TEMPLATE_REGEX.exec(template);
  }

  return variables;
};

export const containsTemplateVariables = (template: string): boolean => {
  const variables = getTemplateVariableNames(template);

  return Boolean(variables.length);
};

export const getSanitizedValuesFromParsedURLQuery = (
  parsedQuery: ParsedUrlQuery,
  variableNames: string[]
) => {
  const kv: Record<string, string> = {};

  variableNames.forEach((name) => {
    if (typeof parsedQuery[name] === 'string') {
      kv[name] = sanitize(parsedQuery[name], {
        allowedTags: [],
        allowedAttributes: {},
      });
    }
  });

  return kv;
};

export const renderTemplate = (
  template: string,
  kv: Record<string, string>
) => {
  const replacer = (_: string, variable: string) => {
    if (!kv[variable]) {
      console.error('Template: "%s" variable value not found', variable);

      return '';
    }

    return kv[variable];
  };

  return template.replace(TEMPLATE_REGEX, replacer);
};
